<template>
    <div class="header-box" :class="{ 'fixed': scrollTop > 0 }">
        <div class="header-main">
            <div class="main-left">
                <!--                <img class="logo-img" :src="require('@/assets/home/logo.png')" alt="">-->
                <span class="title">{{ $t('header.title') }}</span>
            </div>
            <img class="menu-img" :src="require('@/assets/home/navigation.png')" alt="" @click="menuToggle">
        </div>
        <div class="header-menu" :class="{ 'show': menuShow }">
            <a-menu v-model="currents" mode="inline">
                <template v-for="(item, index) in menuList">
                    <template v-if="!item.children?.length">
                        <a-menu-item :key="item.key" @click="selectMenu(item)">{{ $t(`header.menus.${index}.name`)
                            }}</a-menu-item>
                    </template>
                    <template v-else>
                        <a-sub-menu>
                            <span slot="title" class="submenu-title-wrapper" @click="selectMenu(item)">{{
                                $t(`header.menus.${index}.name`) }}</span>
                            <a-menu-item v-for="subItem in item.children" :key="subItem.key"
                                @click="selectMenu(subItem)">
                                {{ $t(`header.menus.${index}.children.${itemIndex}`) }}
                            </a-menu-item>
                        </a-sub-menu>
                    </template>
                </template>
            </a-menu>
        </div>
        <div class="menu-mask" :class="{ 'show': menuShow }" @click="menuToggle"></div>

        <div class="langBtn" @click="changeLang">{{ otherLang }}</div>
    </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
    props: {
        scrollTop: {
            type: Number,
            default: 0,
        },
        current: {
            type: Array,
            default: () => ["home"],
        },
        menuList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            moment,
            otherLang: 'Switch To English',
            currnLang: 'zh-cn',
            currents: [],
            menuShow: false
        }
    },
    watch: {
        current: {
            immediate: true,
            deep: true,
            handler(val, oldName) {
                this.currents = val
                // console.log("点击了新的菜单", val, oldName);
            },
        },
    },
    methods: {
        changeLang() {
            if (this.currnLang == 'zh-cn') {
                this.$i18n.locale = 'en-us'

                this.moment.locale('en-us')
                this.currnLang = 'en-us'
                this.otherLang = '切换中文'
            } else {
                this.$i18n.locale = 'zh-cn'

                this.moment.locale('zh-cn')
                this.currnLang = 'zh-cn';
                this.otherLang = 'Switch To English'
            }
        },
        menuToggle() {
            this.menuShow = !this.menuShow
        },
        // 点击菜单
        selectMenu(item) {
            const { key, children, path } = item
            if (children?.length) return
            if (this.currents.includes(key)) return
            this.$router.push(path)
        },
    }
}
</script>

<style lang="less" scoped>
.header-box {
    // position: absolute;
    // top: 0;
    // width: 100%;
    z-index: 1000;
    position: relative;

    &.fixed {
        // position: fixed;
        // background-color: rgba(255, 255, 255, .3);
        // backdrop-filter: blur(20px);
    }

    .header-main {
        position: relative;
        padding: 20px 16px;
        z-index: 1002;
        background-color: #FFFFFF;

        display: flex;
        justify-content: space-between;
        align-items: center;

        .main-left {
            display: flex;
            align-items: center;

            .logo-img {
                width: auto;
                height: 20px;
            }

            .title {
                margin-left: 10px;
                font-size: 20px;
            }

        }

        .menu-img {
            width: 24px;
            height: auto;
        }
    }

    .header-menu {
        position: absolute;
        left: 0;
        right: 0;
        height: 0;
        background: #FFFFFF;
        overflow: auto;
        box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.1);
        transition: height 250ms;
        z-index: 1002;

        &.show {
            height: 320px;
        }
    }

    .menu-mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 0;
        transition: opacity 250ms;
        z-index: 999;

        &.show {
            right: 0;
            opacity: 1;
        }
    }
}

.ant-menu-vertical>.ant-menu-item,
.ant-menu-vertical-left>.ant-menu-item,
.ant-menu-vertical-right>.ant-menu-item,
.ant-menu-inline>.ant-menu-item,
/deep/.ant-menu-vertical>.ant-menu-submenu>.ant-menu-submenu-title,
/deep/.ant-menu-vertical-left>.ant-menu-submenu>.ant-menu-submenu-title,
/deep/.ant-menu-vertical-right>.ant-menu-submenu>.ant-menu-submenu-title,
/deep/.ant-menu-inline>.ant-menu-submenu>.ant-menu-submenu-title {
    height: auto !important;
    font-size: 16px !important;
    line-height: 2.857 !important;
}

/deep/.ant-menu-submenu-vertical>.ant-menu-submenu-title .ant-menu-submenu-arrow,
/deep/.ant-menu-submenu-vertical-left>.ant-menu-submenu-title .ant-menu-submenu-arrow,
/deep/.ant-menu-submenu-vertical-right>.ant-menu-submenu-title .ant-menu-submenu-arrow,
/deep/.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow {
    right: 16px;
    width: 10px;
}

/deep/.ant-menu-submenu-vertical>.ant-menu-submenu-title .ant-menu-submenu-arrow::before,
/deep/.ant-menu-submenu-vertical-left>.ant-menu-submenu-title .ant-menu-submenu-arrow::before,
/deep/.ant-menu-submenu-vertical-right>.ant-menu-submenu-title .ant-menu-submenu-arrow::before,
/deep/.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow::before,
/deep/.ant-menu-submenu-vertical>.ant-menu-submenu-title .ant-menu-submenu-arrow::after,
/deep/.ant-menu-submenu-vertical-left>.ant-menu-submenu-title .ant-menu-submenu-arrow::after,
/deep/.ant-menu-submenu-vertical-right>.ant-menu-submenu-title .ant-menu-submenu-arrow::after,
/deep/.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow::after {
    width: 6px;
    height: 1.5px;
    border-radius: 2px;
}

/deep/.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow:before,
/deep/.ant-menu-submenu-vertical-left>.ant-menu-submenu-title .ant-menu-submenu-arrow:before,
/deep/.ant-menu-submenu-vertical-right>.ant-menu-submenu-title .ant-menu-submenu-arrow:before,
/deep/.ant-menu-submenu-vertical>.ant-menu-submenu-title .ant-menu-submenu-arrow:before {
    transform: rotate(45deg) translateY(-2px);
}

/deep/.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow:after,
/deep/.ant-menu-submenu-vertical-left>.ant-menu-submenu-title .ant-menu-submenu-arrow:after,
/deep/.ant-menu-submenu-vertical-right>.ant-menu-submenu-title .ant-menu-submenu-arrow:after,
/deep/.ant-menu-submenu-vertical>.ant-menu-submenu-title .ant-menu-submenu-arrow:after {
    transform: rotate(-45deg) translateY(2px);
}

/deep/.ant-menu-submenu-open.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow {
    transform: translateY(-2px);
}

/deep/.ant-menu-submenu-open.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow:before {
    transform: rotate(45deg) translateX(2px);
}

/deep/.ant-menu-submenu-open.ant-menu-submenu-inline>.ant-menu-submenu-title .ant-menu-submenu-arrow:after {
    transform: rotate(-45deg) translateX(-2px);
}

.langBtn {
    border: 1px solid #eee;
    border-radius: 12px;
    box-shadow: 0 1px 8px #eeeeee88;
    cursor: pointer;
    padding: 4px 15px;
    font-weight: bold;
    position: absolute;
    right: 60px;
    top: 22px;
    z-index: 9999;
    font-size: 12px;

    &:hover {
        box-shadow: 0 1px 8px #eee;
    }
}
</style>
